/**
 * IngredientList - Ingredients with Remove/Extra buttons
 */
import { memo } from 'react';

const IngredientList = memo(function IngredientList({ 
  ingredients = [], 
  removedIngredients = [], 
  extraIngredients = [],
  onToggleRemove,
  onToggleExtra,
  isCoreIngredient,
  stepNumber = 1 
}) {
  if (ingredients.length === 0) return null;

  return (
    <div>
      <h4 className="font-medium text-base mb-2 flex items-center gap-2">
        <span className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-xs text-primary font-bold">
          {stepNumber}
        </span>
        Ingredients
      </h4>
      <p className="text-xs text-muted-foreground mb-2">
        Tap remove to exclude from your order.
      </p>
      <div className="space-y-2">
        {ingredients.map(ing => {
          const isRemoved = removedIngredients.includes(ing.name);
          const hasExtra = extraIngredients.find(e => e.name === ing.name);
          // Check if ingredient can be removed (not core and not explicitly non-removable)
          const canRemove = ing.removable !== false && !isCoreIngredient(ing.name);
          
          return (
            <div 
              key={ing.name}
              className="flex items-center justify-between p-3 bg-card rounded-xl border border-border"
            >
              <span className={`font-medium text-sm ${isRemoved ? 'line-through text-muted-foreground' : ''}`}>
                {ing.name}
                {!canRemove && (
                  <span className="ml-2 text-xs text-muted-foreground">(essential)</span>
                )}
              </span>
              <div className="flex gap-2">
                {canRemove && (
                  <button
                    onClick={() => onToggleRemove(ing.name)}
                    data-testid={`remove-${ing.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                      isRemoved
                        ? 'bg-red-500 text-white'
                        : 'bg-red-100 text-red-600 hover:bg-red-200 dark:bg-red-900/30 dark:text-red-400'
                    }`}
                  >
                    {isRemoved ? 'Removed' : 'Remove'}
                  </button>
                )}
                {(ing.extra_price > 0 || ing.price > 0) && (
                  <button
                    onClick={() => onToggleExtra(ing)}
                    data-testid={`extra-${ing.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                      hasExtra
                        ? 'bg-green-500 text-white'
                        : 'bg-green-100 text-green-600 hover:bg-green-200 dark:bg-green-900/30 dark:text-green-400'
                    }`}
                  >
                    Extra +${(ing.extra_price || ing.price).toFixed(2)}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default IngredientList;
